import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useAuthStore} from '@/stores/auth';
import {useRoute, useRouter} from "vue-router";
import {onMounted} from "vue";
import {show_modal} from "@/utils/modal";
import {getQuery} from "@/utils/tools";


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

onMounted(async () => {
    if (route.query.msg) {
        const msg = getQuery("msg");
        await router.replace({
            path: route.path,
            query: {}
        })
        await show_modal("訊息", msg, 3000);
    }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[13] || (_cache[13] = _createElementVNode("h1", null, "歡迎!", -1)),
    _withDirectives(_createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "您似乎尚未登入", -1)),
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "請先", -1)),
        _createVNode(_component_router_link, { to: "/login" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("登入", -1)
          ]))]),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "或", -1)),
        _createVNode(_component_router_link, { to: "/signup" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("註冊", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", null, "接著", -1))
    ], 512), [
      [_vShow, !_unref(useAuthStore)().isLoggedIn]
    ]),
    _createElementVNode("p", null, [
      _cache[8] || (_cache[8] = _createElementVNode("span", null, "您可以到", -1)),
      _createVNode(_component_router_link, { to: "/problems" }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
          _createTextVNode("公開題目", -1)
        ]))]),
        _: 1
      }),
      _cache[9] || (_cache[9] = _createElementVNode("span", null, "寫寫題目", -1))
    ]),
    _createElementVNode("p", null, [
      _cache[11] || (_cache[11] = _createElementVNode("span", null, "或到", -1)),
      _createVNode(_component_router_link, { to: "/contests" }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode("競賽列表", -1)
        ]))]),
        _: 1
      }),
      _cache[12] || (_cache[12] = _createElementVNode("span", null, "參與競賽", -1))
    ])
  ], 64))
}
}

})